import React, { Fragment } from 'react';
import classnames from 'classnames';
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from 'react-dnd';
// import withDragDropContext from '../../../../WithDragDropContext';

import './index.less';

class Container extends React.Component {
    constructor(props) {
        super(props);
    }
    render(){
        return <div {...this.props} />;
    }
}

// const DndProvider = withDragDropContext(Container);

class rightDnd extends React.Component{
    constructor(props){
        super(props);
        this.state = { hoverIndex: -1 };
    }
    updateHoverIndex = index => {
        this.setState({ hoverIndex: index });
    }   
    render(){
        let { updateDragIndex } = this.props;
        let content = <div className="dnd-list">
            {
                this.props.list.map((renderItem, index) => <DragItem 
                    key={renderItem.key}
                    item={renderItem}
                    index={index}
                    hoverIndex = {this.state.hoverIndex}
                    onStart={index => updateDragIndex(index)}
                    // onStop={() => updateDragIndex(-1)}
                    onDrop={this.handleDrop}
                    onHover={this.handleHover}
                />)
            }
        </div>;
        // return (
        //     isWidget ? content : <DndProvider>
        //         {content}
        //     </DndProvider>
        // );
        return content;
    }

    handleDrop = dropIndex => {
        const { onStop } = this.props;
        if(dropIndex === -1){
            console.warn('something wrong, no drag item');
        }
        onStop?.(dropIndex);
    }

    handleHover = (dragIndex, hoverIndex, dragItem) => {
        let addItem; //要添加的元素
 
        if(dragItem?.props?.className?.includes("left-column-dnd")) { //拖拽左侧
            console.log('handleHover', hoverIndex);
            this.updateHoverIndex(hoverIndex);
            return; 
        } else {
            let item = this.props.list.splice(dragIndex, 1);
            addItem = item[0]; 
        }
        this.props.list.splice(hoverIndex, 0, addItem);
        this.forceUpdate();
    }
}

class leftDnd extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        let { updateDragIndex } = this.props;
        let content = <div className="dnd-left-list">
            {
                this.props.list.map((renderItem, index) => <DragItem 
                    key={renderItem.key}
                    item={renderItem}
                    index={index}
                    onStart={index => {updateDragIndex(index);}}
                    // onStop={()=>{}}
                    // onDrop={this.handleDrop}
                    onHover={()=>{}}
                />)
            }
        </div>;
        return content; 
    }
}

export { leftDnd, rightDnd };

//  流程 beginDrag -- hover -- drop -- endDrag
const ItemTypes = { ITEM: 'item' };
const sourceActions = { // 拖拽起始相关函数
    beginDrag(props) { // 开始拖拽，存储拖拽下标
        props.onStart?.(props.index);
        // return的数据为monitor.getItem的数据
        
        if(props.item.props.className.includes("left-column-dnd")) { 
            console.log('左侧元素beginDrag', props);
            return { index:-1, dragItem:props.item }; //代表拖拽的左侧元素
       
        } else {
            console.log('右侧元素beginDrag', props);
            return { index: props.index }; //代表拖拽的右侧元素
        }
    },
    endDrag(props) { // 结束拖拽，清除拖拽下标
        props.onStop?.(props.index);
    },
    canDrag(props) {
        return props.item.props.draggable;
    },
};
const destinationActions = {
    drop(props) { // 放置，此时monitor存储的index已经变了(hover已交换位置)
        const dropIndex = props.index;
        props.onDrop?.(dropIndex);
    },

    // hover到Item，根据是否超过hover Item高度的一半来判断是否需要重新排序
    hover(props, monitor, component) { // hover发生（位置过半） 交换位置
        if(!props.item.props.draggable) {return;} //不支持拖拽的不处理
        
        let item = monitor.getItem();
        console.log('hover');
        const dragIndex = item.index;
        const dragItem = item.dragItem; // 拖拽的元素
        const hoverIndex = props.index;
        if (dragIndex === hoverIndex) {return;} // hover结束后，index已变，此时会相等
        if(dragIndex===-1 || dragItem?.props?.className?.includes("left-column-dnd")) {
            console.log('hover=> 触发左侧hover,入参', dragIndex, hoverIndex, dragItem );
            props.onHover?.(dragIndex, hoverIndex, dragItem);
            monitor.getItem().index = hoverIndex;
            return;
        }
        console.log('hover=> 触发右侧hover');
        // hover项DOM的边界
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // hover项的中间位置
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // 拖拽项的偏移量
        const clientOffset = monitor.getClientOffset();

        // 拖拽项距离hover项 顶部的偏移量
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        props.onHover?.(dragIndex, hoverIndex, dragItem);
        monitor.getItem().index = hoverIndex;
    },

    canDrop(props) {
        return props.item.props.draggable;
    },
};

@DropTarget(ItemTypes.ITEM, destinationActions, connect => ({ connectDropTarget: connect.dropTarget() }))
@DragSource(ItemTypes.ITEM, sourceActions, (connect, monitor) => ({ connectDragSource: connect.dragSource(), isDragging: monitor.isDragging() }))
class DragItem extends React.Component {
    constructor() {
        super();
    }

    render() {
        const {
            connectDragSource,
            connectDropTarget,
            isDragging,
            item,
            index,
            hoverIndex,
        } = this.props;
        let text = item.props?.children[1].props.children;
        return (
            <>
                {connectDropTarget(connectDragSource(
                    <div title={text} className={classnames("dnd-item", 
                        { 
                            dragging: isDragging,
                            hovering: index === hoverIndex,
                        })}>
                        {item}
                    </div>,
                ))}
            </>
        );
    }
}